export enum ResultOptions {
  GENERATE_REPORT = 1,
  GENERATE_REPORT_AND_SEND = 2,
  SEND_DEVELOPMENT = 3,
}

export enum SharedType {
  SEND_DEVELOPMENT = 1,
  GENERATE_REPORT_AND_SEND = 2,
}
